import { createReducer, on } from '@ngrx/store';
import { GhUserProfileDto } from '../../../api/administration/models/gh-user-profile-dto';
import * as UserAuthActions from './user-auth.actions';
import * as AuthActions from '../../auth/auth.actions';

export interface UserAuthState {
  userDetails: GhUserProfileDto | null;
  isLoading: boolean;
  error: string | null;
}

export const initialState: UserAuthState = {
  userDetails: null,
  isLoading: false,
  error: null,
};

export const userAuthReducer = createReducer(
  initialState,
  on(UserAuthActions.loadUserDetails, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(UserAuthActions.loadUserDetailsSuccess, (state, { response }) => ({
    ...state,
    isLoading: false,
    userDetails: response?.data?.[0] ?? null,
    error: null,
  })),
  on(UserAuthActions.loadUserDetailsFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(UserAuthActions.resetUserAuth, AuthActions.logout, () => ({
    ...initialState,
  }))
);
